export const Gandhinagar = {
    title: "Gandhinagar",
    title1: "(Capital City of Gujarat)",

    intro: "Gandhinagar, the capital city of Gujarat, is known for its well-planned infrastructure, lush greenery, and serene environment. Named after Mahatma Gandhi, the city is a hub of government offices, educational institutions, and cultural landmarks, reflecting a blend of modernity and tradition.",

    attractions: [
        {
            name: "Akshardham Temple",
            description: "A stunning architectural marvel dedicated to Lord Swaminarayan, Akshardham Temple is one of the most iconic landmarks in Gandhinagar. The temple complex features intricate carvings, a musical fountain, and exhibitions showcasing Indian culture and spirituality. It is a must-visit for its spiritual ambiance and breathtaking beauty.",
            location: "J Road, Sector 20, Gandhinagar",
            timings: "9:30 AM to 7:30 PM (Closed on Mondays)",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening for the light and sound show",
            activities: [
                "Admire the temple's architecture",
                "Attend the light and sound show",
                "Explore the exhibitions on Indian culture",
                "Participate in the evening Aarti",
                "Enjoy the lush gardens around the temple"
            ],
            mapLink: "https://maps.app.goo.gl/5z8X9Z7Q1yJz3y3Q8",
        },
        {
            name: "Indroda Nature Park",
            description: "Known as the 'Jurassic Park of India,' Indroda Nature Park is a sprawling green space featuring a dinosaur fossil park, a zoo, and a botanical garden. It is a perfect destination for nature lovers and families, offering a unique blend of education and recreation.",
            location: "Sector 7, Gandhinagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "INR 20 for adults, INR 10 for children",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the dinosaur fossil park",
                "Visit the zoo and botanical garden",
                "Enjoy a picnic in the lush greenery",
                "Take a nature walk",
                "Learn about wildlife conservation"
            ],
            mapLink: "https://maps.app.goo.gl/4zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Sarita Udyan",
            description: "A picturesque garden located on the banks of the Sabarmati River, Sarita Udyan is a popular spot for relaxation and leisure. The garden features beautiful landscapes, fountains, and a children's play area, making it an ideal place for families and nature enthusiasts.",
            location: "Near Sabarmati Riverfront, Gandhinagar",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Stroll through the gardens",
                "Enjoy the fountain show",
                "Relax by the riverfront",
                "Take children to the play area",
                "Capture scenic photographs"
            ],
            mapLink: "https://maps.app.goo.gl/3zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Adalaj Stepwell",
            description: "A historic stepwell located on the outskirts of Gandhinagar, Adalaj Stepwell is a fine example of Indo-Islamic architecture. Built in the 15th century, the stepwell served as a resting place for travelers and is adorned with intricate carvings and sculptures.",
            location: "Adalaj, Gandhinagar District",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Admire the architectural beauty",
                "Learn about the history of the stepwell",
                "Capture the intricate carvings",
                "Enjoy the peaceful ambiance",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/2zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Capital Complex",
            description: "The administrative heart of Gandhinagar, the Capital Complex houses the Gujarat State Assembly and other government offices. The area is known for its impressive architecture and well-maintained gardens, offering a glimpse into the city's governance.",
            location: "Sector 10, Gandhinagar",
            timings: "10:00 AM to 5:00 PM (Weekdays)",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the government buildings",
                "Walk through the gardens",
                "Learn about Gujarat's governance",
                "Capture architectural photographs",
                "Attend public events (if any)"
            ],
            mapLink: "https://maps.app.goo.gl/1zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Punit Van",
            description: "A unique garden dedicated to trees and plants mentioned in Indian scriptures, Punit Van is a serene and educational destination. The garden features a variety of flora, along with informative plaques detailing their significance in ancient texts.",
            location: "Sector 19, Gandhinagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the diverse plant species",
                "Learn about trees mentioned in scriptures",
                "Enjoy a peaceful walk",
                "Meditate in the tranquil environment",
                "Capture photographs of the greenery"
            ],
            mapLink: "https://maps.app.goo.gl/0zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Children's Park",
            description: "A fun-filled park designed for children, this attraction features play equipment, rides, and open spaces for kids to enjoy. It is a popular spot for families to spend quality time together.",
            location: "Sector 5, Gandhinagar",
            timings: "10:00 AM to 7:00 PM",
            ticket: "INR 10 per person",
            bestTimeToVisit: "Evening",
            activities: [
                "Let children enjoy the play area",
                "Take a family stroll",
                "Enjoy the rides",
                "Have a picnic",
                "Capture fun moments"
            ],
            mapLink: "https://maps.app.goo.gl/9zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Deer Park",
            description: "A natural habitat for deer and other wildlife, Deer Park is a peaceful retreat for nature lovers. Visitors can observe deer in their natural surroundings and enjoy the tranquil environment.",
            location: "Sector 7, Gandhinagar",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Observe deer and other wildlife",
                "Enjoy a nature walk",
                "Capture photographs",
                "Relax in the serene environment",
                "Learn about wildlife conservation"
            ],
            mapLink: "https://maps.app.goo.gl/8zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Hanumanji Temple",
            description: "A revered temple dedicated to Lord Hanuman, this spiritual site attracts devotees from across the region. The temple is known for its peaceful ambiance and religious significance.",
            location: "Sector 16, Gandhinagar",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers",
                "Attend the Aarti",
                "Meditate in the peaceful environment",
                "Explore the temple architecture",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/7zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Sector 21 Market",
            description: "A bustling market in Gandhinagar, Sector 21 Market is a hub for shopping, dining, and entertainment. Visitors can explore a variety of shops, eateries, and local vendors.",
            location: "Sector 21, Gandhinagar",
            timings: "10:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Shop for local products",
                "Try Gujarati cuisine",
                "Explore the market stalls",
                "Enjoy street food",
                "Interact with local vendors"
            ],
            mapLink: "https://maps.app.goo.gl/6zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Swarnim Park",
            description: "A beautifully landscaped park, Swarnim Park is a popular spot for jogging, walking, and relaxation. The park features lush greenery, fountains, and seating areas.",
            location: "Sector 17, Gandhinagar",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Go for a jog or walk",
                "Relax in the seating areas",
                "Enjoy the fountain show",
                "Capture scenic photographs",
                "Spend time with family"
            ],
            mapLink: "https://maps.app.goo.gl/5zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Gandhi Ashram",
            description: "A smaller counterpart to the Sabarmati Ashram, this ashram in Gandhinagar is dedicated to Mahatma Gandhi's teachings and principles. It serves as a center for learning and reflection.",
            location: "Sector 12, Gandhinagar",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Learn about Gandhi's life",
                "Attend workshops and seminars",
                "Meditate in the peaceful environment",
                "Explore the library",
                "Participate in community activities"
            ],
            mapLink: "https://maps.app.goo.gl/4zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Vithalapur Hanuman Temple",
            description: "A famous temple located near Gandhinagar, this site is dedicated to Lord Hanuman and is known for its spiritual significance and peaceful ambiance.",
            location: "Vithalapur, Gandhinagar District",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers",
                "Attend the Aarti",
                "Meditate in the serene environment",
                "Explore the temple surroundings",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/3zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Rani Roopmati Mosque",
            description: "A historic mosque located near Gandhinagar, this site is known for its architectural beauty and historical significance. It is a peaceful place for reflection and exploration.",
            location: "Mehmudabad, Gandhinagar District",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Admire the mosque's architecture",
                "Learn about its history",
                "Meditate in the peaceful environment",
                "Capture photographs",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/2zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Science City",
            description: "A state-of-the-art science museum and educational center, Science City offers interactive exhibits, a planetarium, and various science-themed attractions. It is a great destination for families and students.",
            location: "Sarkhej-Gandhinagar Highway, Gandhinagar",
            timings: "10:00 AM to 6:00 PM",
            ticket: "INR 50 for adults, INR 30 for children",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore interactive exhibits",
                "Visit the planetarium",
                "Attend science shows",
                "Learn through hands-on activities",
                "Enjoy the IMAX theater"
            ],
            mapLink: "https://maps.app.goo.gl/1zX9Y7Q1yJz3y3Q8",
        }
    ]
};